import { memo } from "react";

import ListGroup from "react-bootstrap/ListGroup";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useNavigate } from "react-router-dom";

import useWindowDimensions from "../utils/hooks/getWindowDimensions";
import { getCurrentUser, getFullName } from "../utils/utils";
import { DrawerMenuItems } from "../utils/constants";
import { ReactComponent as LogOutIcon } from "../static/icons/logout.svg";
import { logOut } from "../services/AuthService";

const Drawer = ({ open, setDrawerOpen, paymentModalOpen }) => {
  const user = getCurrentUser();
  const navigate = useNavigate();
  const { width } = useWindowDimensions();

  return (
    <Offcanvas
      className="menu-canvas"
      show={open || width > 550}
      scroll
      backdrop={false}
    >
      <Offcanvas.Body>
        <ListGroup variant="flush">
          {DrawerMenuItems(user)
            .filter((i) => !i?.roles || i.roles?.includes(user?.role))
            .map((item) => (
              <ListGroup.Item
                action
                active={location.pathname === item.path}
                className={paymentModalOpen && "payment-overlay"}
                onClick={() => {
                  if (item?.onClick) {
                    item.onClick();
                  }
                  navigate(item.path);
                  setDrawerOpen(false);
                }}
                key={item.label}
              >
                {item.label}
              </ListGroup.Item>
            ))}
          <ListGroup.Item className="logout-btn">
            <span style={{ fontSize: "18px !important" }}>
              {getFullName(user)}
            </span>
            <span
              style={{ cursor: "pointer", paddingLeft: "8px" }}
              onClick={logOut}
            >
              <LogOutIcon />
            </span>
          </ListGroup.Item>
        </ListGroup>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default memo(Drawer);
